// This is a modal for Adminvendorstwo

import { Button as AIMEButton } from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useDispatch } from "react-redux";
import {
  addAccountHistoryItem,
  updateMembersItem,
} from "./redux/slices/MembersThunks";

export default function ModalAdminmemberstatus({
  onClose,
  data,
  setData,
  setOldData,
  oldData,
}) {
  const dispatch = useDispatch();

  const handler = async () => {
    try {
      const date = Date.now();
      const res = await dispatch(updateMembersItem(data));
      const historyData = {
        account_id: data.account_id,
        action: "Account status changed by admin.",
        created_at: date,
      };
      await dispatch(addAccountHistoryItem(historyData));
      setOldData(data);
      onClose();
    } catch (e) {
      console.log(e, "error");
    }
  };

  return (
    <RootWrapperModalAdminvendorstwo>
      <Wrapper>
        <Sector>
          <Left>
            <Frame58>
              <Frame1391>
                <Tag>Status</Tag>
              </Frame1391>
              <Frame1391>
                <PRTNR.Select
                  label="Select Status"
                  options={[
                    { value: "Active", label: "Active" },
                    { value: "Freeze", label: "Freeze" },
                  ]}
                  value={data.profile_status}
                  onChange={(e) => {
                    setData({ ...data, profile_status: e.target.value });
                  }}
                />
              </Frame1391>
              <Frame59>
                <AIMEButton
                  size="small"
                  onClick={() => {
                    setData(oldData);
                    onClose();
                  }}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    borderRadius: "999px",
                    background: "rgb(241, 245, 249)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    boxSizing: "border-box",
                    padding: "16px 32px",
                  }}
                >
                  <span
                    style={{
                      color: "rgb(33, 37, 67)",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "110%",
                      textAlign: "left",
                    }}
                  >
                    Cancel
                  </span>
                </AIMEButton>

                <AIMEButton
                  size="small"
                  onClick={() => {
                    handler();
                  }}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    gap: "10px",
                    borderRadius: "48px",
                    width: "240px",
                    background: "rgb(97, 98, 197)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    boxSizing: "border-box",
                    padding: "16px 32px",
                  }}
                >
                  <span
                    style={{
                      color: "white",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "110%",
                      textAlign: "left",
                    }}
                  >
                    Save
                  </span>
                </AIMEButton>
              </Frame59>
            </Frame58>
          </Left>
        </Sector>
        <Frame1392
          src="https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/53e34803-8172-405a-9a0d-9d6b73ba13f0"
          alt="icon"
        />
      </Wrapper>
    </RootWrapperModalAdminvendorstwo>
  );
}

const RootWrapperModalAdminvendorstwo = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  box-sizing: border-box;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  border-radius: 32px;
  width: 534px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
`;

const Sector = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 486px;
  box-sizing: border-box;
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 486px;
  box-sizing: border-box;
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1391 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Tag = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;


const Frame59 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;


const Frame1392 = styled.img`
  width: 32px;
  height: 32px;
  object-fit: cover;
`;
